import { Element } from '@thive/canvas';
import { FloorplanRevision, Obstacle } from '@thive/fddm-types';

import { modifyColor, AREAS_COLORS_MAP } from '@/modules/floorplanDesign/mappers/colors';
import { FDDM_TAG } from '@/modules/floorplanDesign/constants';
import { Z_INDEX_MAP } from '@/modules/canvas/constants/elements';
import { elementFactory } from '@/modules/canvas/factories';

import { segmentToRectangle, segmentsToPathPoints } from './mapperHelpers';

const createObstacleElement = (
  obstacle: FloorplanRevision['design']['obstacles'][number],
): Element | null => {
  // for walls, create a linePath element instead of a Rect element
  if (obstacle.appearance === 'WALL') {
    const firstSegment = obstacle.segments[0];
    if (!firstSegment) return null;

    return elementFactory.buildSegmentElement({
      id: obstacle.id,
      points: segmentsToPathPoints(obstacle.segments),
      z: Z_INDEX_MAP[FDDM_TAG.WALL],
      stroke: {
        color: modifyColor(AREAS_COLORS_MAP.OBSTACLE, true),
        width: firstSegment.leftSideWidth + firstSegment.rightSideWidth,
      },
      color: modifyColor(AREAS_COLORS_MAP.OBSTACLE, true),
      interactivity: {
        draggable: true,
        rotatable: false,
        selectable: true,
        editable: true,
      },
      tags: [FDDM_TAG.WALL],
    });
  }

  const firstSegment = obstacle.segments[0];
  if (!firstSegment) return null;

  return elementFactory.buildRectangleElement({
    id: obstacle.id,
    rectangle: segmentToRectangle(firstSegment),
    z: Z_INDEX_MAP[FDDM_TAG.OBSTACLE],
    color: modifyColor(AREAS_COLORS_MAP.OBSTACLE, true),
    interactivity: {
      draggable: true,
      rotatable: true,
      selectable: true,
      scalable: true,
      snappable: true,
      clickable: false,
    },
    tags: [FDDM_TAG.OBSTACLE],
    stroke: {
      color: '#00000000',
      width: 0,
    },
  });
};

export const obstacleMapper = (obstacles: Obstacle[]): Element[] =>
  obstacles.flatMap((obstacle) => {
    const element = createObstacleElement(obstacle);
    return element ? [element] : [];
  });
